import { json, redirect } from "react-router-dom";
import AuthForm, { EMAIL_KEY, PASSWORD_KEY } from "../components/AuthForm";
import { PARAMS } from "../util/GlobalConstants";
import { loginUser, signupUser } from "../authApi";

function AuthenticationPage() {
  return <AuthForm />;
}

export default AuthenticationPage;

export async function action({ request }) {
  const searchParams = new URL(request.url).searchParams;
  const mode = searchParams.get(PARAMS.mode.mode) || PARAMS.mode.login;

  if (mode !== PARAMS.mode.login && mode !== PARAMS.mode.signup) {
    throw json({ message: "Unsupported mode." }, { status: 422 });
  }

  const data = await request.formData();
  const authData = {
    email: data.get(EMAIL_KEY),
    password: data.get(PASSWORD_KEY),
  };

  const submitFn = mode === PARAMS.mode.login ? loginUser : signupUser;

  let result;
  try {
    result = await submitFn(authData);
  } catch (error) {
    throw json({ message: "Could not authenticate user." }, { status: 500 });
  }

  if (!result.ok) {
    if (result.status === 429) {
      return {
        message: result.data.message,
        retryAfter: result.data.retry_after_seconds ?? null,
      };
    }
    return result.data;
  }

  return redirect("/");
}
